/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconWaveSquare = createReactComponent("wave-square", "IconWaveSquare", [
  ["path", { d: "M3 12h5v8h4v-16h4v8h5", key: "svg-0" }]
]);

export { IconWaveSquare as default };
//# sourceMappingURL=IconWaveSquare.js.map
